import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value", "selected", "disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'dropdown',
  props: /*#__PURE__*/_mergeModels({
    id: {},
    name: {},
    label: {},
    options: {},
    placeholder: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel(__props, "modelValue");

const onChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  model.value = target.value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "form-label",
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 9 /* TEXT, PROPS */, _hoisted_1),
    _createElementVNode("select", {
      id: _ctx.id,
      name: _ctx.id,
      onChange: onChange,
      class: "dropdown__select"
    }, [
      (_ctx.placeholder)
        ? (_openBlock(), _createElementBlock("option", {
            key: 0,
            value: _ctx.placeholder,
            selected: "",
            disabled: ""
          }, _toDisplayString(_ctx.placeholder), 9 /* TEXT, PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value,
          selected: option.selected ? true : undefined,
          disabled: option.disabled ? true : undefined
        }, _toDisplayString(option.name), 9 /* TEXT, PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})